import { baseApi } from "../baseApi";

export const UserManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    postUserLogs: builder.mutation({
      query: (body) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_api_user_logs`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostUserLogsMutation } = UserManagementApi;
